<template>
    <div v-bind="$attrs">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                :small="small"
                v-bind="attrs"
                v-on="on"
                :color="copied ? 'success' : undefined"
                @click="copyToClipboard"
            >
                <v-icon :small="small">
                {{ copied ? 'mdi-check' : 'mdi-content-copy' }}
                </v-icon>
            </v-btn>
            </template>
            <span>{{ copied ? 'Copiado!' : tooltipText }}</span>
        </v-tooltip>
    </div>
</template>

<script setup>

import { ref, defineProps } from 'vue'

const props = defineProps({
  text: { type: String, required: true },
  tooltipText: { type: String, default: "Copiar" },
  small: { type: Boolean, default: false },
})

const copied = ref(false)

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(props.text)
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 1500)
  } catch (e) {
    //
  }
}

</script>